import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_plus",
  "use": "dashboard_card_icon_menu_plus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_plus\"><path d=\"M4 10h12M10 4v12\" stroke=\"#2D2C34\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol